export const filterCustomerPortfolio = (customers, filters, search) => {
  if (!customers || customers.length === 0) return [];
  let customerResult = customers;
  if (search !== '') {
    const searchStr = search.replace('-', '').toLowerCase();
    customerResult = customerResult.filter(c => {
      const matchRegno = c.subjectRegno.startsWith(searchStr);
      const matchName = c.subjectName.toLowerCase().includes(searchStr);
      return matchRegno || matchName;
    });
  }
  customerResult = filterIndividualOrCompany(customerResult, filters);
  customerResult = filterCreditRating(customerResult, filters);
  customerResult = filterDefaultRegistry(customerResult, filters);
  customerResult = filterOutstandingDebt(customerResult, filters);
  customerResult = filterInvoiceCount(customerResult, filters);

  return customerResult;
};

const filterOutstandingDebt = (customers, filters) => {
  const {
    outstandingDebt: { min, max },
    initOutstandingMax
  } = filters;
  const isInitialFilterState = min === 0 && max === initOutstandingMax;
  return customers.filter(c => {
    if (!isInitialFilterState && c.isPBSExcluded) return false;
    const checkMin = c.pbsOutstandingAmountAll >= min;
    const checkMax = c.pbsOutstandingAmountAll <= max;
    return checkMin && checkMax;
  });
};

const filterInvoiceCount = (customers, filters) => {
  const {
    countMax: { min, max },
    initCountMax
  } = filters;
  const isInitialFilterState = min === 0 && max === initCountMax;
  return customers.filter(c => {
    if (!isInitialFilterState && c.isPBSExcluded) return false;
    return c.pbsOutstandingCountAll >= min && c.pbsOutstandingCountAll <= max;
  });
};

const filterDefaultRegistry = (customers, filters) => {
  return customers.filter(c => {
    if (!c.isMonitoredDD) {
      if (
        filters.notOnDDRegistry ||
        filters.sevGroup1 ||
        filters.sevGroup2 ||
        filters.sevGroup3 ||
        filters.sevGroupOther
      ) {
        return false;
      }
      return true;
    }

    const sev = c.ddSeverityMax;
    let res = true;
    if (filters.notOnDDRegistry) {
      res = false;
      if (c.currentOnDDRegistry === 0) return true;
    }
    if (filters.sevGroup1) {
      res = false;
      if (sev === 1) return true;
    }
    if (filters.sevGroup2) {
      res = false;
      if (sev === 2) return true;
    }
    if (filters.sevGroup3) {
      res = false;
      if (sev === 3) return true;
    }
    if (filters.sevGroupOther) {
      res = false;
      if (sev === 4) return true;
    }
    return res;
  });
};

// Filter if company or individual. Having both chosen does nothing.
const filterIndividualOrCompany = (customers, filters) => {
  let result = customers;

  if (filters.deceased) {
    result = customers.filter(c => !c.isCurrent);
  }

  if (filters.individual && !filters.company) {
    result = result.filter(c => c.subjectRegno < '4000000000');
  } else if (filters.company && !filters.individual) {
    result = result.filter(c => c.subjectRegno >= '4000000000');
  }

  return result;
};

// Filter by credit rating. Very low - Low - Possible - High - Not calculated.
const filterCreditRating = (customers, filters) => {
  return customers.filter(c => {
    if (!c.isMonitoredCIP) {
      if (
        filters.cipNotCalculated ||
        filters.veryLowRisk ||
        filters.lowRisk ||
        filters.possibleRisk ||
        filters.highRisk
      ) {
        return false;
      }
      return true;
    } else {
      if (filters.cipNotCalculated && c.currentCIPScore === null) return true;
    }

    if (c.currentCIPScore === null) {
      if (
        filters.cipNotCalculated ||
        filters.veryLowRisk ||
        filters.lowRisk ||
        filters.possibleRisk ||
        filters.highRisk
      )
        return false;
      return true;
    }

    let res = true;
    let score = c.currentCIPScore.trim();

    if (filters.cipNotCalculated) {
      res = false;
      if (score.startsWith('X') || score === '101' || score === '103' || score === '104') {
        return true;
      }
    }
    if (filters.veryLowRisk) {
      if (c.ddSeverityMax > 0) return false;
      res = false;
      if (score.startsWith('A') || score === '1' || score === '2') return true;
    }
    if (filters.lowRisk) {
      if (c.ddSeverityMax > 0) return false;
      res = false;
      if (score.startsWith('B') || score === '3' || score === '4') return true;
    }
    if (filters.possibleRisk) {
      if (c.ddSeverityMax > 0) return false;
      res = false;
      if (score.startsWith('C') || score === '5' || score === '6' || score === '7') return true;
    }
    if (filters.highRisk) {
      if (c.ddSeverityMax > 0) return false;
      res = false;
      if (score.startsWith('D') || score.startsWith('E')) return true;
      if (score === '8' || score === '9' || score === '10') return true;
    }
    return res;
  });
};
